import { jsx as _jsx } from "react/jsx-runtime";
import GenericSettingsPage from './GenericSettingsPage';
const MaterialTypesPage = () => {
    const columns = [
        { key: 'name', label: 'Name', type: 'text', required: true },
        { key: 'description', label: 'Description', type: 'text' },
        { key: 'sort_order', label: 'Sort Order', type: 'number', min: 0 },
    ];
    return (_jsx(GenericSettingsPage, { tableName: "material_types", title: "Construction", columns: columns, apiPath: "material_types" }));
};
export default MaterialTypesPage;
